module.exports = __webpack_public_path__ + "f31fa7e7778d05bffc25e59f614f05e0.svg";